import SectionCard from '@/components/common/SectionCard/SectionCard';
import ImportingToolFileUpload from './FileUploadForm/ImportingToolFileUpload';
import ImportingToolUploadedFiles from './FileUploadGrid/ImportingToolUploadedFiles';

export default function ImportingToolContainer() {
  return (
      <>
      <SectionCard
        padding={true}
        title={{ titleText: 'File Upload' }}
      >
        <ImportingToolFileUpload />
      </SectionCard>

      <SectionCard
        padding={true}
        title={{ titleText: 'Uploaded Files' }}
        className="mt-20"
      >
        <ImportingToolUploadedFiles />
      </SectionCard>
    </>
  );
}